module.exports = __webpack_public_path__ + "media/customizations/wildflowerranch/logo-a7bdb362fcb9965fae5b43ac6f2f79a9.png";